import React from "react";
import styled from "styled-components";
import {KPI_CHART_COLORS} from "../../common/ChartColors";
import {CalendarContainer} from "react-datepicker";
import {
  BoardSearchDetail,
  BoardSearchResult,
  CalendarBox,
  CalendarIcon,
  ChartContainer,
  ColSpan1,
  ColSpan2,
  ColTitle,
  DateContainer,
  GraySearchButton,
  RangePicker,
  RowSpan
} from "../../assets/GlobalStyles";

export const reportSelectStyle = {
  container: provided => ({...provided, width: '100%', minWidth: 0}),
  control: (provided, state) => ({
    ...provided,
    minHeight: 40,
    height: 40,
    borderColor: state.isFocused ? '#f5811f' : '#e5e5e5',
    borderRadius: 6,
    backgroundColor: state.isDisabled ? '#f5f5f5' : '#fff',
    boxShadow: 'none',
    fontSize: 11,
    cursor: state.isDisabled ? 'not-allowed' : 'pointer',
    '&:hover': {borderColor: state.isDisabled ? '#e5e5e5' : '#f1d4c2'}
  }),
  valueContainer: provided => ({...provided, height: 40, padding: '0 11px'}),
  input: provided => ({...provided, margin: 0, padding: 0}),
  indicatorsContainer: provided => ({...provided, height: 40}),
  indicatorSeparator: () => ({display: 'none'}),
  dropdownIndicator: provided => ({...provided, padding: '0 9px', color: '#888'}),
  singleValue: provided => ({...provided, color: '#444'}),
  placeholder: provided => ({...provided, color: '#aaa'}),
  menu: provided => ({...provided, zIndex: 30, border: '1px solid #e5e5e5', borderRadius: 6, overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,.1)'}),
  option: (provided, state) => ({...provided, padding: '9px 11px', backgroundColor: state.isSelected ? '#fff4e8' : state.isFocused ? '#fffaf6' : '#fff', color: state.isSelected ? '#f5811f' : '#555', fontSize: 11, cursor: 'pointer'})
};

export const ReportPage = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 16px;
`;

export const ReportCard = styled.section`
  position: relative;
  z-index: ${({$condition}) => $condition ? 10 : 1};
  overflow: ${({$condition}) => $condition ? 'visible' : 'hidden'};
  border: 1px solid #e5e8eb;
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 5px 18px rgba(31,41,55,.045);
`;

export const SharedConditionBody = styled.div`
  ${BoardSearchDetail} {
    display: flex;
    flex-direction: column;
    gap: 14px;
    margin: 0;
    padding: 18px 20px 20px;
    background: #fff;
  }

  ${RowSpan} {
    display: grid;
    width: 100%;
    grid-template-columns: repeat(3, minmax(180px, 1fr));
    align-items: stretch;
    gap: 18px;
    margin: 0;
    padding: 0;
  }

  ${BoardSearchDetail} > ${RowSpan}:last-of-type {
    grid-template-columns: minmax(250px, 1fr);
    align-items: end;
  }

  ${BoardSearchDetail} > ${RowSpan}:last-of-type > ${ColSpan2} { display:none; }

  ${RowSpan} > ${ColSpan1}, ${RowSpan} > ${ColSpan2} {
    display: block;
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    padding: 0;
  }

  ${RowSpan} > ${ColSpan1} > ${ColTitle}, ${RowSpan} > ${ColSpan2} > ${ColTitle} {
    width: auto;
    min-width: 0;
    margin-bottom: 8px;
    padding: 0;
    color: #555;
    font-size: 11px;
    font-weight: 700;
  }

  ${RowSpan} > ${ColSpan1} > div:last-child,
  ${RowSpan} > ${ColSpan2} > div:last-child,
  .report-select {
    display: block !important;
    width: 100% !important;
    min-width: 0 !important;
    max-width: none !important;
    flex: none !important;
  }

  ${DateContainer} {
    width: 360px;
    max-width: 100%;
    height: 40px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fff;
  }

  ${CalendarBox} { width: 40px; min-width: 40px; min-height: 38px; border-right: 1px solid #f1e4da; background: #fff8f1; }
  ${CalendarIcon} { width: 16px; height: 18px; background-size: 16px 18px; opacity: .82; }
  ${DateContainer} .react-datepicker-wrapper, ${DateContainer} .react-datepicker__input-container { width: 100%; height: 38px; }
  ${DateContainer} input { width: 100%; height: 38px !important; box-sizing: border-box; padding: 0 12px !important; border: 0 !important; background: #fff !important; font-size: 11px !important; box-shadow: none !important; }

  .react-datepicker__day--keyboard-selected:not(.react-datepicker__day--selected):not(.react-datepicker__day--in-range) {
    background: transparent;
    color: inherit;
  }

  ${RangePicker} {
    display: flex;
    width: 100%;
    height: 40px;
    box-sizing: border-box;
    align-items: center;
    justify-content: flex-start;
    gap: 6px;
    margin: 0;
    padding: 4px 6px;
    border: 1px solid #e5e5e5;
    border-radius: 6px;
    background: #fff;
    color: #737b83;
    font-size: 10px;
    overflow-x: auto;
  }

  ${RangePicker} > div:empty { display: none; }
  ${RangePicker} > div:not(:empty) {
    display:inline-flex;height:30px;flex:0 0 auto;align-items:center;justify-content:center;
    box-sizing:border-box;padding:0 10px;border:1px solid transparent;border-radius:5px;
    background:#fff;color:#737b83;cursor:pointer;white-space:nowrap;transition:.14s ease;
  }
  ${RangePicker} > div:not(:empty):hover {border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
  ${RangePicker} > div:not(:empty)[style*="font-weight"] {border-color:#f1d4c2;background:#fff4e8;color:#f5811f !important;}

  ${GraySearchButton} {
    min-width: 82px;
    height: 40px;
    border: 1px solid #f5811f;
    border-radius: 6px;
    background: #f5811f;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    box-shadow: 0 3px 8px rgba(245,129,31,.18);
    cursor: pointer;
  }

  ${GraySearchButton}:hover { border-color: #e87213; background: #e87213; }

  @media (max-width: 1050px) {
    ${BoardSearchDetail} > ${RowSpan}:last-of-type { grid-template-columns: minmax(230px, 1fr) minmax(0, 2fr); }
    ${BoardSearchDetail} > ${RowSpan}:last-of-type > ${ColSpan1}:last-child { grid-column: 1 / -1; text-align: right; }
  }
  @media (max-width: 900px) { ${RowSpan} { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
  @media (max-width: 620px) {
    ${RowSpan}, ${BoardSearchDetail} > ${RowSpan}:last-of-type { grid-template-columns: 1fr; }
    ${BoardSearchDetail} > ${RowSpan}:last-of-type > ${ColSpan1}:last-child { grid-column: auto; }
    ${BoardSearchDetail} > ${RowSpan}:last-of-type > ${ColSpan1}:last-child button { width: 100%; }
  }
`;

export const SharedChartBody = styled.div`
  padding: 18px 20px 20px;
  background: #fff;
  ${ChartContainer} { overflow: hidden; border: 0; border-radius: 0; background: transparent; }
`;

export function ReportMetricSelector({metrics, onToggle, totals}) {
  return <>
    <MetricHeader>
      <div><MetricTitle>차트 지표</MetricTitle><MetricDescription>확인할 지표를 선택하면 차트에 바로 반영됩니다.</MetricDescription></div>
      {totals && <ReportTotalCards exposureCount={totals.exposureCount} costAmount={totals.costAmount} compact/>}
    </MetricHeader>
    <MetricButtons>
      {metrics.map(metric => <MetricChoice key={metric.id} type="button" $active={metric.active} $color={metric.color} onClick={() => onToggle(metric.id)} aria-pressed={metric.active}>
        <MetricCheck $active={metric.active} $color={metric.color}/><strong>{metric.label}</strong>
      </MetricChoice>)}
    </MetricButtons>
  </>;
}

export function ReportConditionActions({onReset, onApply}) {
  return <ReportConditionFooter>
    <ReportConditionGuide>조건을 설정한 뒤 적용 버튼을 눌러 보고서 데이터를 조회합니다.</ReportConditionGuide>
    <ReportConditionButtons>
      <ReportResetButton type="button" onClick={onReset}>초기화</ReportResetButton>
      <ReportApplyButton type="button" onClick={onApply}>적용</ReportApplyButton>
    </ReportConditionButtons>
  </ReportConditionFooter>;
}

export function ReportDatePresets({active, onSelect}) {
  const presets = [['thisMonth','이번달'],['lastMonth','지난달'],['today','오늘'],['lastDay','어제'],['lastWeekDay','지난7일'],['lastThirtyDay','지난30일'],['lastNinetyDay','지난90일']];
  return <DatePresetPanel>
    <DatePresetTitle>빠른 기간 선택</DatePresetTitle>
    <DatePresetButtons>{presets.map(([value,label]) => <DatePresetButton key={value} type="button" $active={active === value} onClick={event => {event.preventDefault();event.stopPropagation();onSelect(value);}}>{label}</DatePresetButton>)}</DatePresetButtons>
  </DatePresetPanel>;
}

export function ReportCalendarContainer({className, children, active, onSelect}) {
  return <ReportCalendarShell className={className}>
    <ReportCalendarMain>{children}</ReportCalendarMain>
    <ReportDatePresets active={active} onSelect={onSelect}/>
  </ReportCalendarShell>;
}

const ReportCalendarShell = styled(CalendarContainer)`
  display:flex !important;align-items:stretch;overflow:hidden;

  .react-datepicker__navigation--next {
    right: 122px;
  }
`;
const ReportCalendarMain = styled.div`
  display:flex;align-items:stretch;
`;

const DatePresetPanel = styled.div`
  display:flex;width:112px;min-height:286px;box-sizing:border-box;align-self:stretch;
  flex-direction:column;padding:12px 10px;border-top:0;border-left:1px solid #eee;background:#fafbfc;
`;
const DatePresetTitle = styled.div`
  margin-bottom:9px;color:#777;font-size:10px;font-weight:700;text-align:center;
`;
const DatePresetButtons = styled.div`
  display:flex;flex:1;flex-direction:column;gap:5px;overflow-y:auto;
`;
const DatePresetButton = styled.button`
  width:100%;height:30px;flex:0 0 auto;padding:0 8px;border:1px solid ${({$active}) => $active ? '#f1d4c2' : '#e5e8eb'};
  border-radius:5px;background:${({$active}) => $active ? '#fff4e8' : '#fff'};color:${({$active}) => $active ? '#f5811f' : '#666'};
  font-size:9px;font-weight:${({$active}) => $active ? 700 : 500};cursor:pointer;
  &:hover{border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
`;

const ReportConditionFooter = styled.div`
  display:flex;width:100%;grid-column:1 / -1;align-items:center;justify-content:space-between;
  gap:14px;margin-top:2px;
  @media(max-width:620px){align-items:stretch;flex-direction:column;}
`;
const ReportConditionGuide = styled.div`color:#999;font-size:9px;line-height:1.5;`;
const ReportConditionButtons = styled.div`
  display:flex;align-items:center;justify-content:flex-end;gap:8px;
  @media(max-width:620px){button{flex:1;}}
`;
const ReportResetButton = styled.button`
  min-width:72px;height:36px;margin:0;padding:0 12px;border:1px solid #dfe3e7;
  border-radius:6px;background:#fff;color:#666;font-size:11px;font-weight:700;cursor:pointer;
  &:hover{border-color:#f1d4c2;background:#fffaf6;color:#f5811f;}
`;
const ReportApplyButton = styled.button`
  min-width:72px;height:36px;margin:0;padding:0 14px;border:1px solid #f5811f;
  border-radius:6px;background:#fff4e8;color:#f5811f;font-size:11px;font-weight:700;cursor:pointer;
  &:hover{background:#ffe8d2;}
`;

export function ReportTotalCards({exposureCount = 0, costAmount = 0, compact = false}) {
  const exposure = Number(exposureCount) || 0;
  const cost = Number(costAmount) || 0;
  const cpv = exposure > 0 ? (cost / exposure) * 1000 : 0;
  const format = value => Math.round(Number(value) || 0).toLocaleString('ko-KR');

  return <TotalCardGrid $compact={compact}>
    <TotalCard $compact={compact} $color={KPI_CHART_COLORS.exposureCount}><TotalIcon $compact={compact} $color={KPI_CHART_COLORS.exposureCount}>노출</TotalIcon><TotalContent $compact={compact}><span>총 노출수</span><strong>{format(exposure)}</strong><small>건</small></TotalContent></TotalCard>
    <TotalCard $compact={compact} $color={KPI_CHART_COLORS.costAmount}><TotalIcon $compact={compact} $color={KPI_CHART_COLORS.costAmount}>비용</TotalIcon><TotalContent $compact={compact}><span>총 비용</span><strong>{format(cost)}</strong><small>원</small></TotalContent></TotalCard>
    <TotalCard $compact={compact} $color={KPI_CHART_COLORS.cpv}><TotalIcon $compact={compact} $color={KPI_CHART_COLORS.cpv}>CPV</TotalIcon><TotalContent $compact={compact}><span>CPV</span><strong>{format(cpv)}</strong><small>원</small></TotalContent></TotalCard>
  </TotalCardGrid>;
}

const TotalCardGrid = styled.div`
  display:grid;grid-template-columns:repeat(3,minmax(0,1fr));
  gap:${({$compact})=>$compact?'6px':'12px'};
  margin-bottom:${({$compact})=>$compact?'0':'16px'};
  ${({$compact})=>$compact&&'min-width:430px;'}
  @media(max-width:900px){min-width:0;}
  @media(max-width:760px){grid-template-columns:${({$compact})=>$compact?'repeat(3,minmax(0,1fr))':'1fr'};}
`;
const TotalCard = styled.div`
  display:flex;min-width:0;box-sizing:border-box;align-items:center;
  min-height:${({$compact})=>$compact?'48px':'74px'};
  gap:${({$compact})=>$compact?'7px':'12px'};
  padding:${({$compact})=>$compact?'7px 9px':'13px 15px'};
  border:1px solid ${({$color})=>`${$color}26`};border-radius:9px;background:${({$color})=>`${$color}08`};
`;
const TotalIcon = styled.span`
  display:inline-flex;align-items:center;justify-content:center;border-radius:7px;
  width:${({$compact})=>$compact?'28px':'38px'};height:${({$compact})=>$compact?'28px':'38px'};
  flex:0 0 ${({$compact})=>$compact?'28px':'38px'};
  background:${({$color})=>`${$color}18`};color:${({$color})=>$color};font-size:8px;font-weight:800;
`;
const TotalContent = styled.div`
  display:flex;min-width:0;align-items:baseline;gap:3px;flex-wrap:wrap;
  >span{width:100%;margin-bottom:${({$compact})=>$compact?'1px':'3px'};color:#858d95;font-size:${({$compact})=>$compact?'8px':'10px'};}
  >strong{overflow:hidden;color:#343a40;font-size:${({$compact})=>$compact?'12px':'17px'};font-weight:800;text-overflow:ellipsis;white-space:nowrap;}
  >small{color:#9299a0;font-size:8px;}
`;

const MetricHeader = styled.div`display:flex;align-items:center;justify-content:space-between;gap:18px;margin-bottom:14px;@media(max-width:900px){align-items:flex-start;flex-direction:column;}`;
const MetricTitle = styled.strong`display:block;color:#2f3438;font-size:13px;font-weight:700;`;
const MetricDescription = styled.span`display:block;margin-top:4px;color:#8b929a;font-size:10px;`;
const MetricButtons = styled.div`display:flex;align-items:center;justify-content:flex-start;gap:8px;margin:14px 0 2px;flex-wrap:wrap;`;
const MetricChoice = styled.button`
  display:inline-flex;height:30px;align-items:center;gap:7px;padding:0 8px;border:0;border-radius:5px;
  background:transparent;color:#444;text-align:left;cursor:pointer;
  opacity:${({$active})=>$active?1:.4};transition:background-color .15s ease,opacity .15s ease;
  strong{font-size:11px;font-weight:600;}
  &:hover{background:#f7f8f9;opacity:1;}
  &:focus-visible{outline:1px solid #f5811f;outline-offset:2px;}
`;
const MetricCheck = styled.span`
  display:inline-block;width:8px;height:8px;flex:0 0 8px;box-sizing:border-box;
  border:2px solid ${({$color})=>$color};border-radius:2px;
  background:${({$active,$color})=>$active?$color:'#fff'};
`;

export const SharedTableBody = styled.div`
  padding: 10px 12px 12px;
  background: #fff;
  ${BoardSearchResult} { margin: 0; padding: 0; border: 0; background: #fff; }
  && .InovuaReactDataGrid { border: 0 !important; border-radius: 0 !important; box-shadow: none !important; }
`;

export const ExcelButton = styled.button`
  display: inline-flex;
  min-width: 88px;
  height: 34px;
  align-items: center;
  justify-content: center;
  padding: 0 12px;
  border: 1px solid #d7e5d9;
  border-radius: 6px;
  background: #f7fbf7;
  color: #47774d;
  font-size: 10px;
  font-weight: 700;
  cursor: pointer;
  &:hover { border-color: #bcd6c0; background: #eef7ef; }
`;

export function ReportConditionSummary({items = []}) {
  return <ConditionSummaryWrap>
    {items.filter(item => item?.value !== undefined && item?.value !== null && item?.value !== '')
      .map(item => <ConditionSummaryItem key={item.label}><span>{item.label}</span><strong title={String(item.value)}>{item.value}</strong></ConditionSummaryItem>)}
  </ConditionSummaryWrap>;
}

const ConditionSummaryWrap = styled.div`
  display: flex;
  max-width: min(720px, 58vw);
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
  overflow: hidden;

  @media (max-width: 900px) { display: none; }
`;

const ConditionSummaryItem = styled.span`
  display: inline-flex;
  min-width: 0;
  height: 26px;
  align-items: center;
  gap: 5px;
  padding: 0 8px;
  border: 1px solid #eee2d8;
  border-radius: 999px;
  background: #fffaf6;
  color: #8c9298;
  font-size: 9px;
  white-space: nowrap;

  strong {
    max-width: 120px;
    overflow: hidden;
    color: #d86c15;
    font-weight: 700;
    text-overflow: ellipsis;
  }
`;
